import { motion } from 'motion/react';

interface CheckAnimadoProps {
  /** ok = círculo + ✓; erro = círculo + ✕. */
  estado?: 'ok' | 'erro';
  tamanho?: number;
  /** Cor do traço (padrão: verde de sucesso / vermelho de erro). */
  cor?: string;
  /** Cor do fundo do círculo (padrão: verde/vermelho bem claro). */
  fundo?: string;
  className?: string;
}

// Círculo + ✓ desenhado (400 ms) com um pulinho. Sem arquivo externo.
// As cores padrão vêm dos tokens do tema; cor/fundo permitem a variante
// dourada da oração sem criar um segundo componente.
export default function CheckAnimado({
  estado = 'ok',
  tamanho = 56,
  cor,
  fundo,
  className = '',
}: CheckAnimadoProps) {
  const erro = estado === 'erro';
  const traco = cor ? { stroke: cor } : { className: erro ? 'stroke-danger-500' : 'stroke-success-500' };
  const preenchimento = fundo
    ? { fill: fundo }
    : { className: erro ? 'fill-danger-50' : 'fill-success-50' };

  return (
    <motion.svg
      viewBox="0 0 48 48"
      width={tamanho}
      height={tamanho}
      role="img"
      aria-label={erro ? 'Não deu certo' : 'Deu certo'}
      className={className}
      initial={{ scale: 0.92 }}
      animate={{ scale: [0.92, 1.03, 1] }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
    >
      <circle cx="24" cy="24" r="20" stroke="none" {...preenchimento} />
      <motion.circle
        cx="24"
        cy="24"
        r="21"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        {...traco}
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      />
      {erro ? (
        <motion.path
          d="M17 17 L31 31 M31 17 L17 31"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
          {...traco}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.4, ease: 'easeOut', delay: 0.1 }}
        />
      ) : (
        <motion.path
          d="M14.5 24.5 L21 31 L34 17"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          {...traco}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.4, ease: 'easeOut', delay: 0.1 }}
        />
      )}
    </motion.svg>
  );
}